import React from 'react'

const Gracias = () => {
  return (
    <div className='p-20 bg-blue-300 h-screen'>gracias</div>
  )
}

export default Gracias